import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../services';
import {ErrorModel, ResultModel} from '../../../models';
import {LoggerService} from '../../../services';
const FUNCTION_CODE = 'EXPORTS_INVOICES';

export async function exportInvoices(userData: Record<string, string>, payload: Record<string, unknown>) {
    try {
        LoggerService.logInfo('Action - exportInvoices - Start');

        const exportInvoicesResult = await DashboardService.AdminService.exportInvoices(userData, payload);

        LoggerService.logInfo('Action - exportInvoices - End - Success');

        return ResultModel.newSuccessResult(exportInvoicesResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - exportInvoices - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
